export default __webpack_public_path__ + "static/media/Mom400.2179d87d.jpg";